export default "__VITE_ASSET__DFlhFsdB__"